import React, { FC, useCallback, useState } from 'react';

import { useAppTakeoverPdp } from 'features/app-takeover/hooks/use-app-takeover';
import { CurvedBackground } from 'features/menu/components/product-detail/product-overview/curved-bg';
import {
  ProductImage,
  ProductInformationContainer,
  ProductOverviewContainer,
  ProductTitle,
} from 'features/menu/components/product-detail/product-overview/styled';
import { ProductPriceCalories } from 'features/menu/components/product-detail/product-price-calories';
import { useProductWizardContext } from 'features/menu/components/product-wizard';
import { ProductWizardStep } from 'features/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'features/menu/components/product-wizard/use-product-wizard-flow';
import { LayoutChangeEvent, View } from 'react-native';

import { DeliveryFeesStripe } from 'components/delivery-fees-stripe';
import { FullWidthAutoHeightImage } from 'components/picture';
import { useScrollResetOnMount } from 'state/scroll/hooks/use-scroll-reset-on-mount';
import { primitive } from 'styles/constants';
import { TraceName, stopTrace } from 'utils/performance/trace';

interface ProductOverviewProps {
  productTitle?: string;
}

// NEW - 1M
export const ProductOverview: FC<ProductOverviewProps> = props => {
  const { selectedProductImage } = useProductWizardContext();
  const { currentFlowStep, id } = useProductWizardFlow();
  const [bgHeight, setBgHeight] = useState(0);
  const takeoverPdp = useAppTakeoverPdp(id);

  useScrollResetOnMount();

  const onImageDisplay = useCallback(() => {
    stopTrace(TraceName.MENU_PDP_LOAD, { menuItemId: id, isOneMenu: 'false' });
  }, [id]);

  return (
    <ProductOverviewContainer withSpacing={!!props.productTitle}>
      {props.productTitle ? (
        <ProductTitle
          fontFamily={takeoverPdp?.fontFamily}
          color={takeoverPdp?.summaryPageTextColor}
        >
          {props.productTitle}
        </ProductTitle>
      ) : (
        <>
          {takeoverPdp.isTakeoverActive ? (
            <>
              <FullWidthAutoHeightImage
                source={takeoverPdp?.overviewBottomImage}
                style={{ position: 'absolute', top: takeoverPdp?.overviewBottomImageOffset }}
              />
              <FullWidthAutoHeightImage
                source={takeoverPdp?.overviewTopImage}
                style={[{ position: 'absolute' }, takeoverPdp?.overviewTopImageStyle]}
              />
            </>
          ) : (
            <View
              style={{
                position: 'absolute',
                height: bgHeight,
                width: '100%',
              }}
            >
              <CurvedBackground
                height={bgHeight}
                curveColor={primitive.$white}
                backgroundColor={primitive.$mayoEggWhite}
              />
            </View>
          )}

          <ProductImage
            image={selectedProductImage}
            alt={selectedProductImage.locale?.imageDescription ?? ''}
            onDisplay={onImageDisplay}
            onLayout={({ nativeEvent }: LayoutChangeEvent) => {
              const { height } = nativeEvent.layout;
              const bgHeight = height - height * 0.4;
              setBgHeight(bgHeight);
            }}
          />
        </>
      )}

      <ProductInformationContainer>
        <ProductPriceCalories />
        {currentFlowStep?.step === ProductWizardStep.ProductHome && <DeliveryFeesStripe />}
      </ProductInformationContainer>
    </ProductOverviewContainer>
  );
};
